import { Grid } from "@material-ui/core";
import { Input, SVG } from "sunrise-ui";
import FilterComponent from "../helperComponents/FilterComponent";
// import FilterComponent from "../inputComponents/FilterComponent";
import TextComponent from "../helperComponents/TextComponent";

const TableHeading = (props: any) => {
  return (
    <Grid
      container
      className="d-flex v-center table_heading_box for_placeholder"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid
        item
        xs={6}
        className="d-flex"
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
      >
        <TextComponent title={props.title} fontSize={18} class="mr-2" />

        {props.tab && props.tab !== null && (
          <FilterComponent
            handleFilterDate={props.handleFilterDate}
            setValue={props.setValue}
            value={props.value}
            resetAll={props.resetToAll}
            size="small"
          />
        )}
      </Grid>
      <Grid
        item
        xs={4}
        className="d-flex"
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Grid
          className=" mr-1 search-icon-relative"
          style={{ position: "relative" }}
        >
          <div
            style={{
              position: "absolute",
              zIndex: 1,
            }}
            className="searchIcon_box absolute"
          >
            <SVG type={"searchIcon"} />
          </div>
          {props.searchValue && (
            <div
              style={{
                position: "absolute",
                zIndex: 1,
                top: "0.4rem",
                right: "0.5rem",
              }}
              onClick={() => {
                props.resetSearch();
              }}
            >
              <SVG type="closeSearchApiIcon" />
            </div>
          )}
          <Input
            fonts="normal"
            placeholder={props.placeHolder ? props.placeHolder : "Search"}
            value={props.searchValue}
            className="search-box"
            type="text"
            onChange={(e) => {
              props.setSearchValue(e);
            }}
          />
        </Grid>
        <Grid
          item
          className="downloadIcon_box d-flex v-center h-end pointer"
          onClick={props.handleDownload}
        >
          <SVG type={"download"} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TableHeading;
